import React from 'react';

import Header from '../../components/header/header.component';
import Visit from '../../components/visit/visit.component';
import Footer from '../../components/footer/footer.component';

const VisitPage = (props) => (
  <div className='parent'>
    <Header />

    <Visit {...props} />

    <Footer />
  </div>
);

export default VisitPage;
